export default "__VITE_ASSET__13cc8008__"